import {
	serverAddr,
	fileServerAddr,
	serverAddrForXLSX,
	serverAddrForCSV,
	serverAddrUnAuth,
} from "../networkConfig";
// fileServerAddr
export default {
	uploadQuestionAttachment(params) {
		return fileServerAddr.post(`tasks/question_attachment/upload/`, params, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
	},
	createCategory(params) {
		return serverAddr.post(`tasks/form_category/`, params);
	},
	listAllCategory() {
		return serverAddr.get(`tasks/form_category/?get_all=true`);
	},
	editCategory(id, params) {
		return serverAddr.patch(`tasks/form_category/${id}/`, params);
	},
	deleteCategory(id) {
		return serverAddr.delete(`tasks/form_category/${id}/`);
	},
	addSection(params) {
		return serverAddr.post(`tasks/section/bulk/add/`, params);
	},
	editSection(params) {
		return serverAddr.patch(`tasks/section/bulk/update/`, params);
	},
	deleteSection(id) {
		return serverAddr.delete(`tasks/section/${id}/`);
	},
	deleteTimer(params) {
		return serverAddr.post(`tasks/execution/delete/timer/`, params);
	},
	addForm(params) {
		return serverAddr.post(`tasks/form/`, params);
	},
	editForm(id, params) {
		return serverAddr.patch(`tasks/form/${id}/`, params);
	},
	deleteLicenseAttachments(id) {
		return serverAddr.delete(`tasks/question_attachment/${id}`);
	},
	listSections(id) {
		return serverAddr.get(`tasks/section/?form_id=${id}`);
	},
	listTasks() {
		return serverAddr.get(`/tasks/form/?form_category_id=`);
	},
	deleteForm(id) {
		return serverAddr.delete(`tasks/form/${id}/`);
	},
	addQuestion(params) {
		return serverAddr.post(`tasks/form_question/`, params);
	},
	editQuestion(id, params) {
		return serverAddr.patch(`tasks/form_question/${id}/`, params);
	},
	listQuestion(form) {
		return serverAddr.get(`tasks/form/${form}`);
		// return serverAddr.get(`tasks/form_question/?form_id=${form}&section_id=${section}`);
	},
	deleteQuestion(id) {
		return serverAddr.delete(`tasks/form_question/${id}/`);
	},
	addQuestionAttachment(params) {
		return serverAddr.post(`tasks/question_attachment/bulk/add/`, params);
	},
	addInputType(params) {
		return serverAddr.post(`tasks/input_type/`, params);
	},
	listInputTypes() {
		return serverAddr.get(`tasks/input_type/?get_all=true`);
	},
	addExpectedResponse(params) {
		return serverAddr.post(`tasks/expected_response/`, params);
	},
	patchExpectedResponse(params) {
		return serverAddr.patch(`tasks/expected_response/bulk/update/`, params);
	},
	editExpectedResponse(id, params) {
		return serverAddr.patch(`tasks/expected_response/${id}/`, params);
	},
	getAttachmentURL(params) {
		return serverAddr.post(`common/get-attachment-url/`, params);
	},
	expectedBulkInput(params) {
		return serverAddr.post(`tasks/input_option/bulk/add/`, params);
	},
	expectedBulkInputEdit(params) {
		return serverAddr.patch(`tasks/input_option/bulk/update/`, params);
	},
	bulkAddExpectedResponse(params) {
		return serverAddr.post(`tasks/expected_response/bulk/add/`, params);
	},
	bulkEditExpectedResponse(params) {
		return serverAddr.patch(`tasks/expected_response/bulk/update/`, params);
	},
	getExpectedInputResponse(id, id1) {
		return serverAddr.post(
			`tasks/expected_response/?question_id=${id}&form_id=${id1}`
		);
	},
	listAllDesignations() {
		return serverAddr.post(`users/designations/list/?get_all=true`);
	},
	listAllLocations() {
		return serverAddr.get(`outlet/?get_all=true&type=store`);
	},
	listAllProjects(id) {
		return serverAddr.get(
			`tasks/execution_category_mapping/?form_category=${id}`
		);
	},
	listFormsByCategoryId(id) {
		return serverAddr.get(`tasks/form/?form_category_id=${id}`);
	},
	addProject(params) {
		return serverAddr.post(`tasks/project/add/update/execution/`, params);
	},
	listManageProjects(type) {
		return serverAddr.get(
			`tasks/execution_setup/?project=&execution_type=${type}`
		);
	},
	deleteManageProjects(id) {
		return serverAddr.delete(`tasks/project/${id}/`);
	},
	listActiveProjects(params) {
		return serverAddr.post(`tasks/execution/projects/list/`, params);
	},
	createOneTimeProject(params) {
		return serverAddr.post(`tasks/execution_setup/`, params);
	},
	createExecutionMapping(params) {
		return serverAddr.post(`tasks/execution_category_mapping/`, params);
	},
	patchExecutionCategoryMapping(id, params) {
		return serverAddr.patch(`tasks/execution_category_mapping/${id}/`, params);
	},
	activeProjectFormCategory(params) {
		return serverAddr.post(`tasks/execution/form_categories/list/`, params);
	},
	listActiveProjectFormCategory(params) {
		return serverAddr.post(`tasks/execution/forms/list/`, params);
	},
	listQuestionsOfForms(params) {
		return serverAddr.post(`tasks/execution/form_questions/list/`, params);
	},
	deleteAttachments(id) {
		return serverAddr.post(
			`tasks/execution/form_question_execution_attachment/delete/`,
			id
		);
	},
	submitQuestionInputFromUser(params) {
		return serverAddr.post(`tasks/execution/form_questions/save/`, params);
	},
	listActions(params) {
		// if(page==1){
		// 	return serverAddr.post(`tasks/actions/list/`, params);
		// }else{
		// 	return serverAddr.post(`tasks/actions/list/?page=2`, params);
		// }
		return serverAddr.post(`tasks/actions/list/?get_all=true`, params);
	},
	// listActionsSummary(params) {
	// 	return serverAddr.post(`tasks/actions/summary/`, params);
	// },
	uploadImageAttachment(params) {
		return fileServerAddr.post(`common/upload-image/`, params, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
	},
	taskAction(params) {
		return serverAddr.post(`tasks/actions/add/update/`, params);
	},
	createQuickTask(params) {
		return serverAddr.post(`tasks/execution/create/quick_task/`, params);
	},
	listActionsFiltersDataPage1(params) {
		return serverAddr.post(
			`tasks/execution/with/actions/filters/data/`,
			params
		);
	},
	listActionsPage1(page, page_size, params) {
		return serverAddr.post(
			`tasks/execution/with/actions/?page=${page}&page_size=${page_size}`,
			params
		);
	},
	listActionsSummary(params) {
		return serverAddr.post(
			`/tasks/execution/with/actions/summary/`,
			params
		);
	},
	listActionsPage2(params) {
		return serverAddr.post(`tasks/actions/list/`, params);
	},
	listActionsPage3(id) {
		return serverAddr.get(`tasks/actions/${id}/`);
	},
	ApproveRejectActionFlow(params){
		return serverAddr.post(`/tasks/actions/approve/`, params);
	},
	markRejectActionFlow(params){
		return serverAddr.post(`/tasks/actions/mark/rejected/`, params);
	},
	markApproveActionFlow(params){
		return serverAddr.post(`/tasks/actions/mark/approved/`, params);
	},
	deleteActionAttachmentPage3(params) {
		return serverAddr.post(`tasks/actions/attachment/delete/`, params);
	},
	submitActions(params) {
		return serverAddr.post(`/tasks/actions/mark/submitted/`, params);
	},
	markSubmitted(params) {
		return serverAddr.post(`tasks/execution/mark_submitted/`, params);
	},
	getUsersOnSubmitPage(params) {
		return serverAddr.post(`users/all_users_v1/`, params);
	},
	projectReview(params) {
		return serverAddr.post(
			`/tasks/execution/save/project_execution/data/`,
			params
		);
	},
	////////////////////////////////////////////////////////////////// V2 DASHBOARD APIs //////////////////////////////////////////////////////////////////////////////////

	getCountryList() {
		return serverAddr.get(
			`outlet/location/?type=store,warehouse,central_kitchen,head_office,distribution_centre,regional_office,vendor`
		);
	},
	getProjectsTasksList() {
		return serverAddr.get(`tasks/execution/dashboard/projects/list/`);
	},
	getCategoryList(id) {
		return serverAddr.get(
			`tasks/execution/dashboard/category/list/?project=${id}`
		);
	},
	getFormsList(id) {
		return serverAddr.get(
			`tasks/execution/dashboard/form/list/?form_category=${id}`
		);
	},
	getQuestionsList(id) {
		return serverAddr.get(
			`tasks/execution/dashboard/form_question/list/?form=${id}`
		);
	},
	getDesignationAndUsersList(params) {
		return serverAddr.post(`tasks/execution/dashboard/users/list/`, params);
	},
	getDashboardData(params) {
		return serverAddr.post(`tasks/execution/report/`, params);
	},
	getDashboardDetailedReport(params) {
		return serverAddrForCSV.post(
			`tasks/execution/csv/report/download/`,
			params
		);
	},
	getDashboarLocationReport(params) {
		return serverAddrForCSV.post(
			`tasks/execution/pdf/report/download/`,
			params
		);
	},
	getVerticalDetailReport(params) {
		return serverAddrForXLSX.post(
			`tasks/execution/vertical/csv/report/download/`,
			params
		);
	},
	getFiveKReportPdfData(params) {
		return serverAddrUnAuth.post(
			`tasks/execution/get_project_execution_data/`,
			params
		);
	},
	downloadActionsCSV(params) {
		return serverAddrForCSV.post(`tasks/actions/csv/download/`, params);
	},
	getNonCompliantQuestionDetails(params) {
		return serverAddrForCSV.post(
			`tasks/execution/non_compliant/form_question/list/`,
			params
		);
	},
	launchProjectApi(params) {
		return serverAddr.post(
			`tasks/execution/launch/project/anytime/`,
			params
		);
	},
	getActionsPDFreport(params) {
		return serverAddrUnAuth.post(
			`tasks/actions/pdf/data/`,
			params
		);
	},
};
